import { useEffect } from 'react';

interface SyncHandlers {
  onConnectionChange: (e: CustomEvent) => void;
  onToolSelect: (e: CustomEvent) => void;
}

export const useCalendarSync = (handlers: SyncHandlers) => {
  useEffect(() => {
    window.addEventListener('eventConnected', handlers.onConnectionChange as EventListener);
    window.addEventListener('eventSelected', handlers.onToolSelect as EventListener);

    return () => {
      window.removeEventListener('eventConnected', handlers.onConnectionChange as EventListener);
      window.removeEventListener('eventSelected', handlers.onToolSelect as EventListener);
    };
  }, [handlers]);
};
